import { Form } from 'react-bootstrap'
import Password from '../../../input_fields/Password'
import { useFormik } from 'formik'
import { ChangePasswordSchema } from './ValidationSchema'
import SaveButton from '../../../buttons/SaveButton'
import { useDispatch } from 'react-redux'
import { changePassword } from '../../../../redux/slices/users/profile/ChangePassword'
import { useNavigate } from 'react-router-dom'
import addUpdateHandler from '../../../../utils/addUpdateHandler'
import { toggleChangePasswordModal } from '../../../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export const ChangePasswordFormImport = {
    Form,
    Password,
    useFormik,
    ChangePasswordSchema,
    SaveButton,
    useDispatch,
    changePassword,
    useNavigate,
    addUpdateHandler,
    toggleChangePasswordModal,
    useTranslation
}